const merchantResponse = [
  {
    roi_goal: 8.0,
    max_cpc: '990.00',
    pricing_model: 'EPP',
    ftp_account_name: 'buybuybaby',
    notes: null,
    daily_budget_amount: '20000.00',
    cpc_goal: null,
    slug: 'buybuybaby',
    url: 'https://buybuybaby.com/',
    commission_rate: null,
    is_pacing_enabled: false,
    merch_id: 1179,
    full_name: 'Buy Buy Baby',
    is_pilot: false,
    share_goal: null,
    logo_url: 'https://static.bam-x.com/assets/logos/merchants/buybuybaby.png',
    click_tracker: null,
    is_active: true,
    is_feed_importer_enabled: true,
    expected_import_frequency: 36,
    show_in_dashboard: true,
  },
  {
    roi_goal: 8.0,
    max_cpc: '990.00',
    pricing_model: 'EPP',
    ftp_account_name: 'macys',
    notes: null,
    daily_budget_amount: '20000.00',
    cpc_goal: null,
    slug: 'macys',
    url: 'https://macys.com/',
    commission_rate: null,
    is_pacing_enabled: false,
    merch_id: 1023,
    full_name: "Macy's",
    is_pilot: false,
    share_goal: null,
    logo_url: 'https://static.bam-x.com/assets/logos/merchants/macys.png',
    click_tracker: null,
    is_active: true,
    is_feed_importer_enabled: true,
    expected_import_frequency: 36,
    show_in_dashboard: true,
  },
];

const cartSummary = [
  {
    stats_summary: {
      aov: '105.71',
      total_orders: 9143614,
      total_transactions: '966530034.66',
      total_products: 27135084,
    },
  },
];

const productsData = [
  {
    merch_id: 1023,
    product_brand: 'Smashbox',
    product_name: 'Smashbox Crystalized Photo Finish Aura Shield Primer Water',
    image_url: null,
    store_page_url: 'https://www.macys.com/shop/product/smashbox-crystalized',
    total_quantity: '2302.00',
    total_orders: '590.00',
    total_revenue: '15744.80',
    unit_price_usd: '8.00',
    feed_price_usd: '32.00',
    datetime_created: '2019-10-31T22:06:57Z',
    sale_price: '8.00',
    sale_percent: '75.00',
    is_new: true,
    is_in_stock: true,
  },
  {
    merch_id: 1100,
    product_brand: 'Google',
    product_name: 'Google Home',
    image_url: null,
    store_page_url: 'https://www.bedbathandbeyond.com/store/product/google-home/',
    total_quantity: '1348.00',
    total_orders: '701.00',
    total_revenue: '39028.20',
    unit_price_usd: '29.00',
    feed_price_usd: '129.00',
    datetime_created: '2017-04-03T08:28:04Z',
    sale_price: '129.00',
    sale_percent: '0.00',
    is_new: true,
    is_in_stock: true,
  },
  {
    merch_id: 1023,
    product_brand: 'Unlisted',
    product_name: 'Kenneth cole unlisted mens Buzzer Oxfords',
    image_url: 'https://slimages.macysassets.com/is/image/',
    store_page_url: 'https://www.macys.com/shop/product/kenneth-cole',
    total_quantity: '1305.00',
    total_orders: '666.00',
    total_revenue: '15957.63',
    unit_price_usd: '23.92',
    feed_price_usd: '75.00',
    datetime_created: '2019-11-31T22:06:57Z',
    sale_price: '17.03',
    sale_percent: '77.00',
    is_new: false,
  },
];

const productsData30Days = [
  {
    merch_id: 1023,
    product_brand: 'Gucci',
    product_name: 'Hot shoes',
    image_url: 'https://slimages.gucci.com/is/image/',
    store_page_url: 'https://www.gucci.com/shop/product/shoe',
    total_quantity: '1305.00',
    total_orders: '666.00',
    total_revenue: '15957.63',
    unit_price_usd: '23.92',
    feed_price_usd: '75.00',
    datetime_created: '2019-10-31T22:06:57Z',
    sale_price: '17.03',
    sale_percent: '77.00',
    is_new: false,
  },
];

const cartSiblings = [
  {
    merch_id: 1023,
    product_brand: null,
    product_name: 'Beauty Box Only $15 with any Beauty Purchase!',
    image_url: null,
    store_page_url: null,
    total_quantity: 9,
    total_orders: 9,
    total_revenue: 135.0,
    unit_price_usd: 15.0,
    feed_price_usd: null,
    sale_percent: 0,
    datetime_created: null,
    sale_price: null,
    is_new: false,
    is_in_stock: true,
  },
  {
    merch_id: 1023,
    product_brand: 'Giorgio Armani',
    product_name: 'Giorgio Armani 2-Pc. Gioia Eau de Parfum Gift Set',
    image_url: 'https://slimages.macysassets.com/is/image/MCY/products/7/',
    store_page_url: 'https://www.macys.com/shop/product/giorgio-armani-2-pc',
    total_quantity: 9,
    total_orders: 3,
    total_revenue: 153.0,
    unit_price_usd: 17.0,
    feed_price_usd: 25.0,
    sale_percent: 20.0,
    datetime_created: '2019-12-15T11:41:54.102697+00:00',
    sale_price: 20.0,
    is_new: false,
  },
];

const getProductsData = (params = {}) => {
  let data = productsData;

  // DateRange
  if (params.date_range === '30d') {
    data = productsData30Days;
  }

  // Tab
  if (params.product_type === 'sale') {
    data = data.filter(item => parseFloat(item.sale_percent) > 5);
  } else if (params.product_type === 'new') {
    data = data.filter(item => item.is_new);
  }

  // Sort
  if (params.order_by) {
    data = data.sort((a, b) => {
      return params.direction === 'asc'
        ? a[params.order_by] > b[params.order_by]
        : a[params.order_by] < b[params.order_by];
    });
  }

  // Search
  if (params.search_term) {
    data = data.filter(item => {
      return item.product_name.toLowerCase().match(params.search_term);
    });
  }

  return [
    {
      stats: data,
      page_info: {
        page: 1,
        per_page: 500,
        total_items: 94861,
        total_pages: 190,
      },
    },
  ];
};

const getCartSiblings = (params = {}) => {
  let data = cartSiblings;

  if (params.product_name === 'Google Home') {
    data = cartSiblings[1];
  } else if (params.product_name === 'Kenneth cole unlisted mens Buzzer Oxfords') {
    data = [];
  }

  return [
    {
      stats: data,
      cart_summary: {
        aov: 40.76,
        total_bought_with: 437,
      },
    },
  ];
};

export { merchantResponse, cartSummary, getProductsData, getCartSiblings };
